import { useSelector } from 'react-redux'

import { selectAll } from 'redux/selectors/CustomFields'

export const useCustomFields = () => {
  return useSelector(selectAll)
}
